export interface ProfessionalPlanBenefit {
  description: string;
  id:
    | 'whatsapp-booking'
    | 'whatsapp-reminders'
    | 'additional-professionals'
    | 'business-types'
    | 'unlimited-services'
    | 'whatsapp-verification'
    | 'subscription-price';
  title: string;
}

export const PROFESSIONAL_PLAN_BENEFITS: ProfessionalPlanBenefit[] = [
  {
    id: 'whatsapp-booking',
    title: 'Bot de WhatsApp para reservas',
    description:
      'Puedes activarlo cuando lo necesites para que tus clientes consulten disponibilidad y gestionen citas desde WhatsApp.',
  },
  {
    id: 'whatsapp-reminders',
    title: 'Recordatorios desde la agenda',
    description:
      'Envía recordatorios por WhatsApp desde la agenda cuando lo necesites.',
  },
  {
    id: 'additional-professionals',
    title: 'Más profesionales cuando los necesites',
    description:
      'El plan incluye 1 profesional y permite sumar cupos adicionales por $19.900 COP al mes cada uno.',
  },
  {
    id: 'business-types',
    title: 'Hasta 10 categorías de actividad',
    description:
      'Muestra las diferentes áreas o especialidades que ofrece tu negocio.',
  },
  {
    id: 'unlimited-services',
    title: 'Servicios ilimitados',
    description:
      'Publica más de 3 servicios y muestra una oferta más completa.',
  },
  {
    // TODO(whatsapp-business-verification): la prueba de teléfono del registro
    // no equivale todavía a una verificación comercial visible del perfil.
    id: 'whatsapp-verification',
    title: 'Verificación de números al reservar',
    description:
      'Cuando tus clientes agenden citas, podrás pedir una confirmación del número de teléfono para reducir inasistencias',
  },
  {
    id: 'subscription-price',
    title: '$29.900 COP al mes',
    description:
      'Incluye 1 profesional y puedes cancelar la próxima renovación cuando quieras.',
  },
];
